module.exports = "assets/close.svg?6f4f20e32edcc616b7c41ca5bd69b231";